/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DeviceInputs */

const en_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device`)
};

const es_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo`)
};

const fr_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appareil`)
};

const de_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerät`)
};

const ja_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美容機器`)
};

const zh_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仪器/设备`)
};

const ar_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أجهزة`)
};

const id_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perangkat`)
};

const it_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo / Strumento`)
};

const ru_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аппарат/Устройство`)
};

const pt_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo`)
};

const ko_val_device = /** @type {(inputs: Val_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디바이스`)
};

/**
* | output |
* | --- |
* | "Device" |
*
* @param {Val_DeviceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_device = /** @type {((inputs?: Val_DeviceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DeviceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_device(inputs)
	if (locale === "es") return es_val_device(inputs)
	if (locale === "fr") return fr_val_device(inputs)
	if (locale === "de") return de_val_device(inputs)
	if (locale === "ja") return ja_val_device(inputs)
	if (locale === "zh") return zh_val_device(inputs)
	if (locale === "ar") return ar_val_device(inputs)
	if (locale === "id") return id_val_device(inputs)
	if (locale === "it") return it_val_device(inputs)
	if (locale === "ru") return ru_val_device(inputs)
	if (locale === "pt") return pt_val_device(inputs)
	return ko_val_device(inputs)
});